<template>
  <div>
    <div class="bot_bg1">
      <div class="bot_tit contain">
        <span>友情链接：</span>
        <ul>
          <li>
            <div class="bot_con">
              <p>国家部委网站<i></i></p>
              <dl>
                <dd>
                  <a
                    href="http://www.mod.gov.cn/"
                    target="_blank"
                    title="国防部"
                    >国防部</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.caea.gov.cn"
                    target="_blank"
                    title="原子能机构"
                    >原子能机构</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.cnsa.gov.cn"
                    target="_blank"
                    title="航天局"
                    >航天局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.pbc.gov.cn/"
                    target="_blank"
                    title="人民银行"
                    >人民银行</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.drc.gov.cn/"
                    target="_blank"
                    title="发展研究中心"
                    >发展研究中心</a
                  >
                </dd>

                <dd>
                  <a href="http://www.cae.cn/" target="_blank" title="工程院"
                    >工程院</a
                  >
                </dd>

                <dd>
                  <a
                    href="https://www.ccps.gov.cn/"
                    target="_blank"
                    title="行政学院"
                    >行政学院</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.cbirc.gov.cn/cn/view/pages/index/index.html"
                    target="_blank"
                    title="银保监会"
                    >银保监会</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.cnca.gov.cn/"
                    target="_blank"
                    title="认证认可监管委员会"
                    >认证认可监管委员会</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.csrc.gov.cn/"
                    target="_blank"
                    title="证监会"
                    >证监会</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.forestry.gov.cn/"
                    target="_blank"
                    title="公园管理局"
                    >公园管理局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.sac.gov.cn/"
                    target="_blank"
                    title="标准化管理委员会"
                    >标准化管理委员会</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.saac.gov.cn/"
                    target="_blank"
                    title="档案局"
                    >档案局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.sca.gov.cn/"
                    target="_blank"
                    title="密码局"
                    >密码局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.spb.gov.cn/"
                    target="_blank"
                    title="邮政局"
                    >邮政局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.ncha.gov.cn/"
                    target="_blank"
                    title="文物局"
                    >文物局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.satcm.gov.cn/"
                    target="_blank"
                    title="中医药局"
                    >中医药局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.safe.gov.cn/"
                    target="_blank"
                    title="外汇局"
                    >外汇局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.mps.gov.cn/n2254996/"
                    target="_blank"
                    title="移民管理局"
                    >移民管理局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.caac.gov.cn/"
                    target="_blank"
                    title="民航局"
                    >民航局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.nra.gov.cn/"
                    target="_blank"
                    title="铁路局"
                    >铁路局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.safea.gov.cn/"
                    target="_blank"
                    title="外专局"
                    >外专局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.scs.gov.cn/"
                    target="_blank"
                    title="公务员局"
                    >公务员局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.nmdis.org.cn/"
                    target="_blank"
                    title="海洋局"
                    >海洋局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.sastind.gov.cn/"
                    target="_blank"
                    title="国防科工局"
                    >国防科工局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.nea.gov.cn/"
                    target="_blank"
                    title="能源局"
                    >能源局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tobacco.gov.cn/"
                    target="_blank"
                    title="烟草局"
                    >烟草局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.gjxfj.gov.cn/"
                    target="_blank"
                    title="信访局"
                    >信访局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.cma.gov.cn/"
                    target="_blank"
                    title="气象局"
                    >气象局</a
                  >
                </dd>

                <dd>
                  <a href="http://cass.cssn.cn/" target="_blank" title="社科院"
                    >社科院</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.scio.gov.cn/"
                    target="_blank"
                    title="新闻办"
                    >新闻办</a
                  >
                </dd>

                <dd>
                  <a href="http://www.cas.cn/" target="_blank" title="中科院"
                    >中科院</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.cac.gov.cn/"
                    target="_blank"
                    title="网信办"
                    >网信办</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.xinhuanet.com/"
                    target="_blank"
                    title="新华社"
                    >新华社</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.gov.cn/guoqing/2005-12/26/content_2652073.htm"
                    target="_blank"
                    title="国研室"
                    >国研室</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.gwytb.gov.cn/"
                    target="_blank"
                    title="台办"
                    >台办</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.hmo.gov.cn/"
                    target="_blank"
                    title="港澳办"
                    >港澳办</a
                  >
                </dd>

                <dd>
                  <a href="http://www.gqb.gov.cn/" target="_blank" title="侨办"
                    >侨办</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.ncac.gov.cn/"
                    target="_blank"
                    title="版权局"
                    >版权局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.counsellor.gov.cn/"
                    target="_blank"
                    title="参事室"
                    >参事室</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.sara.gov.cn/"
                    target="_blank"
                    title="宗教局"
                    >宗教局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.forestry.gov.cn/"
                    target="_blank"
                    title="林业和草原局"
                    >林业和草原局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.stats.gov.cn/"
                    target="_blank"
                    title="统计局"
                    >统计局</a
                  >
                </dd>

                <dd>
                  <a
                    href="https://www.nmpa.gov.cn/"
                    target="_blank"
                    title="药品监管局"
                    >药品监管局</a
                  >
                </dd>

                <dd>
                  <a
                    href="https://www.mem.gov.cn/"
                    target="_blank"
                    title="应急管理部"
                    >应急管理部</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.sport.gov.cn/"
                    target="_blank"
                    title="体育总局"
                    >体育总局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.nrta.gov.cn/"
                    target="_blank"
                    title="广播电视总局"
                    >广播电视总局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.samr.gov.cn/"
                    target="_blank"
                    title="市场监管总局"
                    >市场监管总局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.ggj.gov.cn/"
                    target="_blank"
                    title="机关事务局"
                    >机关事务局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.chinatax.gov.cn/"
                    target="_blank"
                    title="税务总局"
                    >税务总局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.sasac.gov.cn/"
                    target="_blank"
                    title="国资委"
                    >国资委</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.customs.gov.cn/"
                    target="_blank"
                    title="海关总署"
                    >海关总署</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.audit.gov.cn/"
                    target="_blank"
                    title="审计署"
                    >审计署</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.nhc.gov.cn/"
                    target="_blank"
                    title="卫生健康委"
                    >卫生健康委</a
                  >
                </dd>

                <dd>
                  <a
                    href="https://www.mct.gov.cn/"
                    target="_blank"
                    title="文化和旅游部"
                    >文化和旅游部</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.fmprc.gov.cn/"
                    target="_blank"
                    title="外交部"
                    >外交部</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.ndrc.gov.cn/"
                    target="_blank"
                    title="发展改革委"
                    >发展改革委</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.moe.gov.cn/"
                    target="_blank"
                    title="教育部"
                    >教育部</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.most.gov.cn/"
                    target="_blank"
                    title="科技部"
                    >科技部</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.miit.gov.cn/"
                    target="_blank"
                    title="工业和信息化部"
                    >工业和信息化部</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.mps.gov.cn/"
                    target="_blank"
                    title="公安部"
                    >公安部</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.seac.gov.cn/"
                    target="_blank"
                    title="国家民委"
                    >国家民委</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://nnsa.mee.gov.cn/"
                    target="_blank"
                    title="核安全局"
                    >核安全局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.mca.gov.cn/"
                    target="_blank"
                    title="民政部"
                    >民政部</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.moj.gov.cn/"
                    target="_blank"
                    title="司法部"
                    >司法部</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.mof.gov.cn/"
                    target="_blank"
                    title="财政部"
                    >财政部</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.mohrss.gov.cn/"
                    target="_blank"
                    title="人力资源社会保障部"
                    >人力资源社会保障部</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.mnr.gov.cn/"
                    target="_blank"
                    title="自然资源部"
                    >自然资源部</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.mee.gov.cn/"
                    target="_blank"
                    title="生态环境部"
                    >生态环境部</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.mohurd.gov.cn/"
                    target="_blank"
                    title="住房城乡建设部"
                    >住房城乡建设部</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.mot.gov.cn/"
                    target="_blank"
                    title="交通运输部"
                    >交通运输部</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.mwr.gov.cn/"
                    target="_blank"
                    title="水利部"
                    >水利部</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://file.mofcom.gov.cn/"
                    target="_blank"
                    title="商务部"
                    >商务部</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.moa.gov.cn/"
                    target="_blank"
                    title="农业农村部"
                    >农业农村部</a
                  >
                </dd>
              </dl>
            </div>
          </li>
          <li>
            <div class="bot_con">
              <p>市、州、林区网站<i></i></p>
              <dl>
                <dd>
                  <a
                    href="http://www.wuhan.gov.cn/"
                    target="_blank"
                    title="武汉市"
                    >武汉市</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.xiangyang.gov.cn/wzsy/"
                    target="_blank"
                    title="襄阳市"
                    >襄阳市</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.yichang.gov.cn/"
                    target="_blank"
                    title="宜昌市"
                    >宜昌市</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.huangshi.gov.cn/"
                    target="_blank"
                    title="黄石市"
                    >黄石市</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.shiyan.gov.cn/"
                    target="_blank"
                    title="十堰市"
                    >十堰市</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.jingzhou.gov.cn/"
                    target="_blank"
                    title="荆州市"
                    >荆州市</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.jingmen.gov.cn/"
                    target="_blank"
                    title="荆门市"
                    >荆门市</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.ezhou.gov.cn/"
                    target="_blank"
                    title="鄂州市"
                    >鄂州市</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.xiaogan.gov.cn/"
                    target="_blank"
                    title="孝感市"
                    >孝感市</a
                  >
                </dd>

                <dd>
                  <a href="http://www.hg.gov.cn/" target="_blank" title="黄冈市"
                    >黄冈市</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.xianning.gov.cn/"
                    target="_blank"
                    title="咸宁市"
                    >咸宁市</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.suizhou.gov.cn/"
                    target="_blank"
                    title="随州市"
                    >随州市</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.enshi.gov.cn/"
                    target="_blank"
                    title="恩施州"
                    >恩施州</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.xiantao.gov.cn"
                    target="_blank"
                    title="仙桃市"
                    >仙桃市</a
                  >
                </dd>

                <dd><a href="" target="_blank" title="天门市">天门市</a></dd>

                <dd>
                  <a
                    href="http://www.hbqj.gov.cn"
                    target="_blank"
                    title="潜江市"
                    >潜江市</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.snj.gov.cn/"
                    target="_blank"
                    title="神农架林区"
                    >神农架林区</a
                  >
                </dd>
              </dl>
            </div>
          </li>
          <li>
            <div class="bot_con">
              <p>市直部门、乡镇信息公开<i></i></p>
              <dl>
                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/sfzhggwyh/"
                    target="_blank"
                    >市发展和改革委员会</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/sjyj/"
                    target="_blank"
                    >市教育局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/skxjsj/"
                    target="_blank"
                    >市科学技术局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/sjjhxxhj/"
                    target="_blank"
                    >市经济和信息化局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/sgaj/"
                    target="_blank"
                    >市公安局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/smzj/"
                    target="_blank"
                    >市民政局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/ssfj/"
                    target="_blank"
                    >市司法局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/sczj/"
                    target="_blank"
                    >市财政局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/srlzyhshbzj/"
                    target="_blank"
                    >市人力资源和社会保障局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/szrzyhghj/"
                    target="_blank"
                    >市自然资源和规划局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/ssthjj/"
                    target="_blank"
                    >市生态环境局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/szfhcxjsj/"
                    target="_blank"
                    >市住房和城乡建设局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/sjtysj/"
                    target="_blank"
                    >市交通运输局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/sslhhbj/"
                    target="_blank"
                    >市水利和湖泊局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/snyncj/"
                    target="_blank"
                    >市农业农村局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/sswj/"
                    target="_blank"
                    >市商务局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/swhhlyj/"
                    target="_blank"
                    >市文化和旅游局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/swsjkwyh/"
                    target="_blank"
                    >市卫生健康委员会</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/styjrswj/"
                    target="_blank"
                    >市退役军人事务局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/syjglj/"
                    target="_blank"
                    >市应急管理局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/ssjj/"
                    target="_blank"
                    >市审计局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/sscjdglj/"
                    target="_blank"
                    >市市场监督管理局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/stjj/"
                    target="_blank"
                    >市统计局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/sylbzj/"
                    target="_blank"
                    >市医疗保障局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/sfpkfbgs/"
                    target="_blank"
                    >市乡村振兴局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/scsglzfj/"
                    target="_blank"
                    >市城市管理执法局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/szwfwhdsjglj/"
                    target="_blank"
                    >市政务服务和大数据管理局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/sggzyjyzx/"
                    target="_blank"
                    >市公共资源交易中心</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/szfbzfwzx/"
                    target="_blank"
                    >市住房保障服务中心</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/szsfwzx/"
                    target="_blank"
                    >市招商服务中心</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/sxdnyfwzx/"
                    target="_blank"
                    >市现代农业服务中心</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/sgxs/"
                    target="_blank"
                    >市供销合作社联合社</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/swj/"
                    target="_blank"
                    >市税务局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/tmdcd/"
                    target="_blank"
                    >调查队</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/sqxj/"
                    target="_blank"
                    >市气象局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/bm/syczmj/"
                    target="_blank"
                    >市烟草专卖局</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/dbz1/"
                    target="_blank"
                    >多宝镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/tsz/"
                    target="_blank"
                    >拖市镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/zgz/"
                    target="_blank"
                    >张港镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/yxz/"
                    target="_blank"
                    >渔薪镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/jcz/"
                    target="_blank"
                    >蒋场镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/wcz/"
                    target="_blank"
                    >汪场镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/htz/"
                    target="_blank"
                    >黄潭镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/ykz/"
                    target="_blank"
                    >岳口镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/xbz/"
                    target="_blank"
                    >小板镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/hlz/"
                    target="_blank"
                    >横林镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/myz/"
                    target="_blank"
                    >麻洋镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/tmgyy/"
                    target="_blank"
                    >多祥镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/psz/"
                    target="_blank"
                    >彭市镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/mwz/"
                    target="_blank"
                    >马湾镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/gyz/"
                    target="_blank"
                    >干驿镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/lsz/"
                    target="_blank"
                    >卢市镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/jtx/"
                    target="_blank"
                    >净潭乡</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/jzz/"
                    target="_blank"
                    >九真镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/hsz/"
                    target="_blank"
                    >胡市镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/zsz/"
                    target="_blank"
                    >皂市镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/sjhz/"
                    target="_blank"
                    >石家河镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/fzsz/"
                    target="_blank"
                    >佛子山镇</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/jhnc/"
                    target="_blank"
                    >蒋湖农场</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/jlbsc/"
                    target="_blank"
                    >竟陵街道办事处</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/hkjdbac/"
                    target="_blank"
                    >侯口街道办事处</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.tianmen.gov.cn/zwgk/bmhxzxxgkml/xzbcy/ylbsc/"
                    target="_blank"
                    >杨林街道办事处</a
                  >
                </dd>
              </dl>
            </div>
          </li>

          <li>
            <div class="bot_con">
              <p>本市相关网站<i></i></p>
              <dl>
                <dd>
                  <a href="http://www.tmwcn.com/" target="_blank" title="天门网"
                    >天门网</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://www.hbtmdj.gov.cn/"
                    target="_blank"
                    title="中共天门市委组织部-天门组工网"
                    >中共天门市委组织部-天门组工网</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://219.138.245.221:9007/ecdomain/tm_web/index.html"
                    target="_blank"
                    title="天门市住房保障网上服务大厅"
                    >天门市住房保障网上服务大厅</a
                  >
                </dd>

                <dd>
                  <a
                    href="http://credit.tianmen.gov.cn/"
                    target="_blank"
                    title="信用中国（湖北天门）"
                    >信用中国（湖北天门）</a
                  >
                </dd>
              </dl>
            </div>
          </li>
        </ul>
        <div class="clear"></div>
      </div>
    </div>
    <div class="contain bot">
      <div class="bot_l">
        <div class="bot_tit1">
          <a href="/qtlm/lxwm" target="_blank">联系我们</a>|
          <a href="javascript:void(0)" @click="showAlertHome"> 设为首页 </a>|
          <a href="javascript:void(0)" @click="showAlertStar"> 加入收藏 </a>|
          <a href="/qtlm/zddt/">站点地图</a>|
          <a href="/qtlm/gywm/" target="_blank">关于我们</a>
        </div>
        <p>
          <span>版权所有：天门市人民政府</span>
          <span>天门市人民政府办公室主管</span>
          <span>天门市政务服务和大数据管理局主办</span>
        </p>
        <p>
          <span>
            12345政务服务便民热线【12345（市内）、0728-4812345（市外）】
          </span>
        </p>
        <p>
          <span>政府网站标识码：4290060001</span>
          <span
            ><a
              href="https://beian.miit.gov.cn/#/Integrated/index"
              target="_blank"
              >鄂ICP备05005537号-1</a
            ></span
          >
          <span
            ><a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42900602000138"
              target="_blank"
              >鄂公网安备42900602000138号</a
            ></span
          >
        </p>
      </div>
      <div class="bot_r">
        <a
          href="http://bszs.conac.cn/sitename?method=show&amp;id=23C5D746B803345AE053022819AC7623"
          target="_blank"
        >
          <img src="../assets/image/red.png"
        /></a>
      </div>
      <div class="bot_r pad_t25">
        <span id="_span_jiucuo"
          ><img
            onclick="Link('4290060001')"
            style="margin: 0; border: 0; cursor: pointer"
            ignoreapd="1"
            src="../assets/image/jiucuo.png"
        /></span>
      </div>
      <div class="bot_r pad_t25">
        <a href="https://www.12377.cn/" target="_blank"
          ><img src="../assets/image/19tm_jb.jpg"
        /></a>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    showAlertHome() {
      window.alert(
        '您好,您的浏览器不支持自动设置页面为首页功能,请您手动在浏览器里设置该页面为首页!'
      )
    },
    showAlertStar() {
      window.alert(
        '加入收藏失败，请使用Ctrl+D进行添加,或手动在浏览器里进行设置.'
      )
    }
  }
}
</script>

<style lang="less">
.clear {
  clear: both;
}
.contain {
  width: 1452px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}
.bot_bg1 {
  border-top: 5px solid #006bc8;
  margin: 20px auto 0;
}
.bot_tit {
  line-height: 32px;
  padding: 21px 0;
  border-bottom: 1px solid #e6e6e6;
}
.bot_tit span {
  font-size: 18px;
  font-weight: bold;
  margin-right: 20px;
  display: block;
  color: #333333;
  float: left;
}
.bot_tit ul {
  width: 90%;
  margin-right: -10px;
  float: left;
}
.bot_tit li {
  float: left;
  width: 25%;
}
.bot_tit li:hover,
.bot_tit li.on {
  color: #333333;
}
.bot_tit li:last-child {
  background: none;
}
.bot_tit li .bot_con {
  margin-right: 10px;
  position: relative;
}
.bot_tit li .bot_con dl {
  display: none;
  position: absolute;
  left: 0px;
  bottom: 33px;
  right: 0px;
  padding-left: 23px;
  height: 180px;
  overflow-y: auto;
  background-color: #ffffff;
  font-size: 14px;
  line-height: 34px;
  border: 1px solid #d9d9d9;
}
.bot_tit li .bot_con p {
  cursor: pointer;
  padding-left: 13px;
  background-color: #ffffff;
  border: 1px solid #d9d9d9;
  height: 32px;
}
.bot_tit li .bot_con p i {
  background: url(@/assets/image/19tm_arr1.png) no-repeat right center;
  width: 10px;
  height: 32px;
  display: inline-block;
  float: right;
  margin-right: 15px;
}
.bot_tit li:hover .bot_con dl {
  display: block;
}
.bot {
  padding: 17px 0 40px 0;
}
.bot_l {
  float: left;
  line-height: 30px;
}
.bot_l span {
  margin-right: 20px;
}
.bot_r {
  float: right;
  padding-top: 18px;
  margin-left: 10px;
}
.bot_tit1 {
  line-height: 40px;
  color: #d9d9d9;
  margin-left: -16px;
}
.bot_tit1 a {
  margin: 0 16px;
  color: #333333;
}
</style>
